import { render, staticRenderFns } from "./OnAir.vue?vue&type=template&id=3cca12df&scoped=true"
import script from "./OnAir.vue?vue&type=script&lang=js"
export * from "./OnAir.vue?vue&type=script&lang=js"
import style0 from "./OnAir.vue?vue&type=style&index=0&id=3cca12df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cca12df",
  null
  
)

export default component.exports